/**
 * Themes are a set of colours based on a base colour. They allow you to provide a single colour
 * (theme) to a component and have the other colours worked out automatically
 */
const themes = {
  none: {
    header: 'primary',
    subHeader: 'primary darken-1',
    backgroundOne: 'layout_5',
    backgroundTwo: 'layout_4',
    vessel: 'primary',
    chip: 'layout_4',
    darkHeader: true,
    darkContent: false,
    icon: 'accent',
    highlight: 'layout_9',
  },
  accent: {
    header: 'accent',
    subHeader: 'accent darken-1',
    backgroundOne: 'accent lighten-1',
    backgroundTwo: 'accent',
    vessel: 'accent',
    chip: 'accent',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'accent darken-2',
  },
  primary: {
    header: 'primary',
    subHeader: 'primary darken-1',
    backgroundOne: 'primary lighten-1',
    backgroundTwo: 'primary',
    vessel: 'primary',
    chip: 'primary',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'primary lighten-2',
  },
  'blue-grey': {
    header: 'blue-grey',
    subHeader: 'blue-grey darken-1',
    backgroundOne: 'blue-grey lighten-1',
    backgroundTwo: 'blue-grey',
    vessel: 'blue-grey',
    chip: 'blue-grey',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'blue-grey lighten-2',
  },
  indigo: {
    header: 'indigo',
    subHeader: 'indigo darken-1',
    backgroundOne: 'indigo lighten-1',
    backgroundTwo: 'indigo',
    vessel: 'indigo',
    chip: 'indigo',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'indigo lighten-2',
  },
  success: {
    header: 'success',
    subHeader: 'success darken-1',
    backgroundOne: 'success lighten-1',
    backgroundTwo: 'success',
    vessel: 'success',
    chip: 'success',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'success lighten-2',
  },
  teal: {
    header: 'teal',
    subHeader: 'teal darken-1',
    backgroundOne: 'teal lighten-1',
    backgroundTwo: 'teal',
    vessel: 'teal',
    chip: 'teal',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'teal lighten-2',
  },
  blue: {
    header: 'blue',
    subHeader: 'blue darken-1',
    backgroundOne: 'blue lighten-1',
    backgroundTwo: 'blue',
    vessel: 'blue',
    chip: 'blue',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'blue darken-1',
  },
  purple: {
    header: 'purple',
    subHeader: 'purple darken-1',
    backgroundOne: 'purple lighten-1',
    backgroundTwo: 'purple',
    vessel: 'purple',
    chip: 'purple',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'purple darken-1',
  },
  'deep-orange': {
    header: 'deep-orange',
    subHeader: 'deep-orange darken-1',
    backgroundOne: 'deep-orange lighten-1',
    backgroundTwo: 'deep-orange',
    vessel: 'deep-orange',
    chip: 'deep-orange',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'deep-orange lighten-2',
  },
  yellow: {
    header: 'yellow darken-1',
    subHeader: 'yellow darken-1',
    backgroundOne: 'yellow lighten-1',
    backgroundTwo: 'yellow',
    vessel: 'yellow',
    chip: 'yellow',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'yellow lighten-2',
  },
  error: {
    header: 'error',
    subHeader: 'error darken-1',
    backgroundOne: 'error lighten-1',
    backgroundTwo: 'error',
    vessel: 'error',
    chip: 'error',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'error lighten-2',
  },
  brown: {
    header: 'brown',
    subHeader: 'brown darken-1',
    backgroundOne: 'brown lighten-1',
    backgroundTwo: 'brown',
    vessel: 'brown',
    chip: 'brown',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'brown lighten-2',
  },
  layout_6: {
    header: 'layout_6',
    subHeader: 'layout_4',
    backgroundOne: 'white',
    backgroundTwo: 'layout_6',
    vessel: 'layout_6',
    chip: 'layout_6',
    darkHeader: false,
    darkContent: false,
    icon: 'accent',
    highlight: 'layout_4',
  },
  layout_4: {
    header: 'layout_4',
    subHeader: 'layout_3',
    backgroundOne: 'layout_5',
    backgroundTwo: 'layout_4',
    vessel: 'layout_4',
    chip: 'layout_4',
    darkHeader: false,
    darkContent: false,
    icon: 'accent',
    highlight: 'layout_4',
  },
  crimsom: {
    header: 'crimsom',
    subHeader: 'crimsom darken-1',
    backgroundOne: 'crimsom lighten-1',
    backgroundTwo: 'crimsom',
    vessel: 'crimsom',
    chip: 'crimsom',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'crimsom',
  },
  dark_green: {
    header: 'dark_green',
    subHeader: 'dark_green darken-1',
    backgroundOne: 'dark_green lighten-1',
    backgroundTwo: 'dark_green',
    vessel: 'dark_green',
    chip: 'dark_green',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'dark_green',
  },
  dark_purple: {
    header: 'dark_purple',
    subHeader: 'dark_purple darken-1',
    backgroundOne: 'dark_purple lighten-1',
    backgroundTwo: 'dark_purple',
    vessel: 'dark_purple',
    chip: 'dark_purple',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'dark_purple',
  },
  dark_blue: {
    header: 'dark_blue',
    subHeader: 'dark_blue darken-1',
    backgroundOne: 'dark_blue lighten-1',
    backgroundTwo: 'dark_blue',
    vessel: 'dark_blue',
    chip: 'dark_blue',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'dark_blue',
  },
  light_blue: {
    header: 'light_blue',
    subHeader: 'light_blue darken-1',
    backgroundOne: 'light_blue lighten-1',
    backgroundTwo: 'light_blue',
    vessel: 'light_blue',
    chip: 'light_blue',
    darkHeader: true,
    darkContent: true,
    icon: 'accemt',
    highlight: 'light_blue',
  },
  green_grey: {
    header: 'green_grey',
    subHeader: 'green_grey darken-1',
    backgroundOne: 'green_grey lighten-1',
    backgroundTwo: 'green_grey',
    vessel: 'green_grey',
    chip: 'green_grey',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'green_grey',
  },
  purple_grey: {
    header: 'purple_grey',
    subHeader: 'purple_grey darken-1',
    backgroundOne: 'purple_grey lighten-1',
    backgroundTwo: 'purple_grey',
    vessel: 'purple_grey',
    chip: 'purple_grey',
    darkHeader: true,
    darkContent: true,
    icon: 'white',
    highlight: 'purple_grey',
  },
  snapshot_group: {
    header: 'layout_3',
    subHeader: 'layout_2',
    backgroundOne: 'layout_6',
    backgroundTwo: 'layout_4',
    vessel: 'layout_3',
    chip: 'layout_3',
    darkHeader: true,
    darkContent: false,
    icon: 'accent',
    highlight: 'accent',
  },
};

export default themes;
